import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'tr-halfpage-template',
  imports: [
    RouterOutlet
  ],
  templateUrl: './halfpage-template.component.html',
  styleUrl: './halfpage-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HalfpageTemplateComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  backgroundImage: string = '';

  constructor() {
    this.updateBackgroundImage();
    this.router.events.subscribe(() => {
      this.updateBackgroundImage();
    });
  }

  private updateBackgroundImage() {
    this.route.firstChild?.data.subscribe(data => {
      this.backgroundImage = data['backgroundImage'] || '';
    });
  }

}
